module.exports = __webpack_public_path__ + "static/media/AssessorTech.c6cc6b6e.png";